module.exports = __webpack_public_path__ + "img/line_chart.72329538.svg";